import { render } from "./CaseDetailPrint.vue?vue&type=template&id=8b8f1a22&scoped=true"
import script from "./CaseDetailPrint.vue?vue&type=script&lang=js"
export * from "./CaseDetailPrint.vue?vue&type=script&lang=js"

import "./CaseDetailPrint.vue?vue&type=style&index=0&id=8b8f1a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8f1a22"]])

export default __exports__